<template>
    <div class="group relative shrink-0">
        <img
            class="h-20 w-20 rounded-lg border border-gray-200 object-cover shadow-sm"
            data-testid="attachment-preview-image"
            :src="attachment.preview"
            :alt="attachment.file.name || previewLabel"
            v-if="isSupportedImageAttachment"
        />

        <div
            class="flex h-20 w-20 flex-col items-center justify-center gap-1 rounded-lg border border-gray-200 bg-gray-50 px-2 py-3 text-center text-[10px] leading-tight text-gray-700 shadow-sm"
            data-testid="attachment-preview-file"
            v-else
        >
            <icon name="regular/common-file-text" class="h-4 w-4 shrink-0 text-gray-500" />

            <span class="max-w-full truncate">{{ attachment.file.name }}</span>
        </div>

        <button
            :class="[
                'absolute -right-1.5 -top-1.5 z-10 h-5 w-5',
                'rounded-full text-red-500 opacity-100 transition-opacity duration-150',
                'hoverable:pointer-events-none hoverable:opacity-0 hoverable:group-hover:pointer-events-auto hoverable:group-hover:opacity-100',
                'hover:text-red-600',
                'focus:pointer-events-auto focus:opacity-100 focus:outline-none focus:ring-2 focus:ring-red-200 focus:ring-offset-1 focus:text-red-600',
            ]"
            :aria-label="removeLabel"
            :title="removeLabel"
            data-testid="attachment-remove-button"
            type="button"
            @click="emit('remove')"
        >
            <remove-circle-icon
                aria-hidden="true"
                class="pointer-events-none block h-full w-full"
                data-testid="attachment-remove-icon"
            />
        </button>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { RemoveCircleIcon } from '@/assets/icons/index.ts';
    import { isImageAttachment } from '@/entities/types/ConversationType.ts';
    import type { Attachment } from '@/entities/types/ConversationType.ts';

    interface Props {
        attachment: Attachment;
        previewLabel: string;
        removeLabel: string;
    }

    const props = defineProps<Props>();

    const emit = defineEmits<{
        (e: 'remove'): void;
    }>();

    const isSupportedImageAttachment = computed<boolean>(() =>
        isImageAttachment(props.attachment.file.type)
    );
</script>
